import React from "react";
import { Box, Grid, Rating, Stack } from "@mui/material";
import LandingHeader from "../../../layout/header";
import Footer from "../../../layout/footer";
import { BlueBox, BtnAccess, ReviewBox } from "../style";
import { RootStyle, Text, Title } from "../style";
import { AboutGrid, AboutText, AboutTitle } from "../style";
import AboutImg from "../../../images/landing/pos module.png";
import Icon1 from "../../../images/landing/pos icon 1.png";
import Icon2 from "../../../images/landing/pos icon 2.png";
import Icon3 from "../../../images/landing/pos icon 3.png";
import PartnerLogo from "../../../images/landing/master.png";
import { Link } from "react-router-dom";
import AccessNow from "../AccessNow";
import { InnerBlueBox } from "../style";

function PosModule() {
  return (
    <Box sx={{ background: "#fff" }}>
      <LandingHeader />
      <RootStyle sx={{ my: "40px" }}>
        <Stack spacing="64px">
          <BlueBox sx={{ minHeight: "163px" }}>
            <InnerBlueBox sx={{ p: "0 0 0 32px", maxHeight: "163px" }}>
              <Grid container>
                <AboutGrid item md={7} xs={12}>
                  <AboutTitle>POS - Point Of Sale System</AboutTitle>
                  <Link to="/inventory/login">
                    <BtnAccess>Access Now</BtnAccess>
                  </Link>
                </AboutGrid>
                <Grid item md={5} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
                  <Box>
                    <img
                      style={{ maxHeight: "163px" }}
                      width="100%"
                      src={AboutImg}
                      alt=""
                    />
                  </Box>
                </Grid>
              </Grid>
            </InnerBlueBox>
          </BlueBox>

          <Stack spacing="40px" alignItems="center">
            <AboutTitle sx={{ color: "#60656C", textAlign: "center" }}>
              Streamline your sales process and boost your business with our
              powerful Point of Sale (POS) System
            </AboutTitle>
            <img src={Icon1} alt="" />
          </Stack>

          <Box
            sx={{
              background: "#FBFFED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={8} xs={12} order={{ xs: 2, md: 1 }}>
                <AboutText>This user-friendly tool allows you to:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Process sales quickly and efficiently:</b> Ring up
                      purchases with ease, scan items, manage discounts, and
                      accept various payment methods.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Link customer ledgers: </b> Integrate your sales with
                      customer accounts for seamless financial management.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Generate instant quotes: </b> Create professional
                      quotes directly from the POS, converting opportunities
                      into sales.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Maintain sales records:</b> Automatically generate and
                      save invoices for every transaction, leaving no room for
                      error.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Manage invoices efficiently:</b> Create and send
                      invoices to clients directly from the POS, with clear and
                      detailed information.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Track outstanding payments:</b> Monitor pending
                      invoices and follow up with clients for timely payments.
                    </AboutText>
                  </li>
                </ul>
              </Grid>
              <Grid item md={4} xs={12} order={{ xs: 1, md: 2 }}>
                <img width="100%" src={Icon2} alt="" />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              background: "#FBFFED",
              p: "64px 32px ",
              borderRadius: "24px",
            }}
          >
            <Grid container spacing="32px">
              <Grid item md={4} xs={12}>
                <img width="100%" src={Icon3} alt="" />
              </Grid>
              <Grid item md={8} xs={12}>
                <AboutText>Benefits:</AboutText>
                <ul>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Increased sales:</b> Simplify the sales process and
                      close deals faster.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Improved customer experience:</b> Offer a seamless and
                      efficient checkout experience.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Enhanced financial control: </b> Integrate sales data
                      with your accounting system for comprehensive financial
                      reporting.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Reduced paperwork:</b> Eliminate the need for manual
                      invoices and save valuable time.
                    </AboutText>
                  </li>
                  <li>
                    <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                      <b>Improved operational efficiency:</b> Streamline your
                      workflow and manage your business more effectively.
                    </AboutText>
                  </li>
                </ul>
                <AboutText sx={{ fontWeight: 500, fontSize: "18px" }}>
                  With the Point of Sale Module, you can simplify your sales
                  operations, improve customer satisfaction, and gain valuable
                  insights into your business performance.
                </AboutText>
              </Grid>
            </Grid>
          </Box>

          <ReviewBox>
            <Grid container spacing="16px">
              <Grid
                item
                md={6}
                xs={12}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Stack>
                  <Text sx={{ color: "#fff" }}>
                    “I am thrilled to share the positive impact this platform
                    has had on our business.First and foremost, the ease of use
                    of ManageKaro's point of sale system has significantly
                    improved our daily operations. The intuitive interface makes
                    transactions seamless, and our staff adapted to the system
                    with minimal training. It's a user-friendly solution that
                    doesn't compromise on functionality.”
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "center", md: "flex-start" },
                    }}
                  >
                    <Rating name="simple-controlled" value={5} />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={6} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={PartnerLogo} alt="" />
                  <Box>
                    <Title sx={{ color: "#fff" }}>Ghazi Paint Store</Title>
                    <Title sx={{ color: "#fff", fontSize: "24px" }}>
                      Mr Ghazi Saeed
                    </Title>
                    <Text sx={{ color: "#fff", fontStyle: "italic" }}>
                      Babaji Kalyamai Plaza, Opp DHA 2, GT Road, Rawalpindi
                    </Text>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </ReviewBox>

          <AccessNow />
        </Stack>
      </RootStyle>
      <Footer />
    </Box>
  );
}

export default PosModule;
